// This file is auto-generated. Edit data.json to change it.
import { DataProvider } from 'Simple/Data'
import useDataOnSubmit from './useDataOnSubmit'
import rdata from './data.json'
import React from 'react'
import Logic from './logic'

/** @type {import('Simple/types.js').Data} */
export default function ContentData(props) {
  let data = rdata.value
  let onSubmit = useDataOnSubmit(props, data)

  return (
    <DataProvider
      context="import_align_images"
      value={data}
      viewPath={props.viewPath}
      onSubmit={onSubmit}
    >
      <Logic {...props} />
    </DataProvider>
  )
}